module.exports = "https://web-assets.ifttt.com/packs/media/diy/chevron-back-1c8eeb32.svg";